import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { getExhExhibitionDaysListUrl, insertUpdateExhExhibitionDaysUrl, GET_EXHIBITION_DAYS_LIST, INSERT_UPDATE_EXHIBITION_DAYS, headers } from "../../../../utils/constants";


export const getExhibitionDaysList_action = (ExihibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
        }

        const res = await axiosGet(getExhExhibitionDaysListUrl, params, headers)

        dispatch({
            type: GET_EXHIBITION_DAYS_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateExhibitionDays_action = (ExihibitionID, ExhibitionDaysList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            ExhibitionDaysList: ExhibitionDaysList,
        }

        const res = await axiosPost(insertUpdateExhExhibitionDaysUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_EXHIBITION_DAYS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}